var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.record.TagsArray),function(tag){return _c('b-link',{key:tag,attrs:{"to":("/explorer/tags/" + (_vm.findTagId(tag)))}},[_c('b-form-tag',{staticClass:"bg-gray-3 text-dark",attrs:{"title":tag,"no-remove":""}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }